import { MapTilerBaseLayerBase } from "./MapTilerBaseLayerBase";
export class MapTilerBasicLayer extends MapTilerBaseLayerBase {
    constructor() {
        super(MapTilerBasicLayer.Url);
    }
    onAfterFetch(style) {
        // update oneway arrows.
        MapTilerBaseLayerBase.removeLayers(style, ["road_oneway", "road_oneway_opposite"]);
        MapTilerBaseLayerBase.addLayer(style, {
            id: "road-oneway",
            type: "symbol",
            source: "openmaptiles",
            "source-layer": "transportation",
            minzoom: 15,
            "layout": {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "icon-size": {
                    "stops": [
                        [
                            15,
                            0.5
                        ],
                        [
                            19,
                            1
                        ]
                    ]
                },
                "icon-image": "oneway",
                "visibility": "visible",
                "icon-rotate": 90,
                "icon-padding": 2,
                "symbol-spacing": 75,
                "symbol-placement": "line",
                "icon-rotation-alignment": "map"
            },
            "paint": {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "icon-opacity": 1
            },
            filter: MapTilerBaseLayerBase.IsOnewayFilter()
        }, "label_airport");
        MapTilerBaseLayerBase.addLayer(style, {
            id: "road-oneway-reverse",
            type: "symbol",
            source: "openmaptiles",
            "source-layer": "transportation",
            minzoom: 15,
            "layout": {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "icon-size": {
                    "stops": [
                        [
                            15,
                            0.5
                        ],
                        [
                            19,
                            1
                        ]
                    ]
                },
                "icon-image": "oneway",
                "visibility": "visible",
                "icon-rotate": -90,
                "icon-padding": 2,
                "symbol-spacing": 75,
                "symbol-placement": "line",
                "icon-rotation-alignment": "map"
            },
            "paint": {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                /* @ts-ignore */
                "icon-opacity": 1
            },
            filter: MapTilerBaseLayerBase.IsOnewayReverseFilter()
        }, "road-oneway");
    }
}
MapTilerBasicLayer.Url = "https://api.maptiler.com/maps/0d19e9c6-3baf-467f-abde-db0e28870f27/style.json?key=OZUCIh4RNx38vXF8gF4H";
